import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'

import { ExpandableDrawerProvider } from '../../../ui/contexts/ExpandableDrawerContext'
import ExpandableDrawer from '../../ExpandableDrawer'
import Extended from './Extended'
import Preview from './Preview'

import { uxEvent } from '../../../../flux/actions/ux'
import { selectLabel } from '../../../../flux/selectors/i18n'
import {
  selectCurrentProductId,
  selectIsWebView,
  selectProductInfoDrawerOpen,
  selectProductInfoMode,
  selectProductInfoModeIsExpanded,
} from '../../../../flux/selectors/ux'

import { CONTEXT_DRAWER, CONTEXT_NAVIGATOR } from '../../../../helpers/const'

const ProductDrawer = ({ children }) => {
  const dispatch = useDispatch()

  const productId = useSelector(selectCurrentProductId)
  const open = useSelector(selectProductInfoDrawerOpen)
  const productInfoDrawerMode = useSelector(selectProductInfoMode)
  const expanded = useSelector(selectProductInfoModeIsExpanded)
  const isWebView = useSelector(selectIsWebView)
  const {
    expand: expandLabel,
    reduce: reduceLabel,
  } = useSelector(selectLabel('extendableDrawer'))

  const onProductDrawerClose = to => {
    dispatch(uxEvent({
      name: 'toggle',
      target: 'ProductInfoDrawer/Close',
      params: {
        productId,
        to,
      },
    }))
  }

  const onProductDrawerSetMode = (mode, action) => {
    dispatch(uxEvent({
      name: 'toggle',
      target: 'ProductInfoDrawer/Mode',
      params: { mode, action, productId },
    }))
  }

  const renderContent = () => {
    if (!open || !productId) {
      return null
    }

    if (!expanded) {
      return (
        <Preview productId={productId} />
      )
    }

    return (
      <Extended
        productId={productId}
        onShowAllSimilarProductsCtaClick={() => onProductDrawerClose(CONTEXT_NAVIGATOR)}
      />
    )
  }

  return (
    <ExpandableDrawerProvider>
      { children }
      <ExpandableDrawer
        open={open}
        mode={productInfoDrawerMode}
        expandLabel={expandLabel}
        reduceLabel={reduceLabel}
        onModeChange={onProductDrawerSetMode}
        onClose={() => onProductDrawerClose(CONTEXT_DRAWER)}
        isWebView={isWebView}
      >
        {renderContent()}
      </ExpandableDrawer>
    </ExpandableDrawerProvider>
  )
}

ProductDrawer.propTypes = {
  children: PropTypes.element.isRequired,
}

export default ProductDrawer
